module.exports = __webpack_public_path__ + "static/media/yemoga-solimar-otero.2c2e2b24.jpg";